export default __webpack_public_path__ + "static/media/headbanner4.9eefa767.jpeg";